import { isEmpty } from './isEmpty'

export function capitalize(value: string): string {
  if (isEmpty(value)) return value
  return value[0].toUpperCase() + value.slice(1).toLowerCase()
}

export function capitalizeWords(value: string): string {
  return value
    .split(' ')
    .map((word) => capitalize(word))
    .join(' ')
}

export function escapeHtml(value: string): string {
  return value
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;')
}

export function joinWithAnd(items: string[]): string {
  if (isEmpty(items)) return ''
  if (items.length === 1) return items[0]
  if (items.length === 2) return `${items[0]} and ${items[1]}`
  return `${items.slice(0, -1).join(', ')}, and ${items[items.length - 1]}`
}
